import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ZoneService, SubZoneService, SubZoneTitleService, BaseService, CenterService } from '../../../mesc/mesc.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { TntToolService }
  from '../../tnt.service';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';

@Component({
  selector: 'app-transfer-tools',
  templateUrl: './transfer-tools.component.html',
  host: { 'class': 'router-outlet' },

  // styleUrls: ['./transfer-tools.component.scss']
})
export class TransferToolsComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    public ZoneService: ZoneService,
    public SubZoneService: SubZoneService,
    public SubZoneTitleService: SubZoneTitleService,
    public CgpAlertDialogService: CgpAlertDialogService,
    public TntToolService: TntToolService,
    public baseService: BaseService,
    public centerService: CenterService

  ) { }
  isDebug: boolean = false;
  show: boolean = false
  isNew: boolean = false
  countFrom: number;
  countTo: number;
  transfer: any;
  ZoneId = '';
  SubZoneId: string;
  SelectedFromZone: any = undefined
  SelectedFromSubZone: any = undefined;
  SelectedToZone: any = undefined;
  SelectedToSubZone: any = undefined;
  fromSubZones: any[] = [];
  toSubZones: any[] = [];
  bodyShopId: string;

  DefaultZone: {
    Description: string;
    ZoneId: string
  } = {
      Description:
        "Select Zone", ZoneId: this.ZoneId
    };

  DefaultSubZone: {
    Description: string;
    SubZoneId: string
  } =
    {
      Description:
        "Select SubZone", SubZoneId: undefined
    };

  dataResultZone: Array<"Zone">;
  dataResultSubZone: Array<"SubZone">;

  @ViewChild('fromComboBox') fromComboBox: ComboBoxComponent;
  @ViewChild('toComboBox') toComboBox: ComboBoxComponent;

  ngOnInit() {
    var self = this;
    this.centerService.read("", true).then(function (response) {
      self.bodyShopId = response.filter(function (center) {
        return center.Description.toUpperCase() === "BODY SHOP";
      })[0].Id;
    })
    this.ZoneService.read("", true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        response[i]["DisplayDescription"] = response[i].Description + " - " + response[i].DetailDescription;
      }
    })
    this.SubZoneService.query();
    this.SubZoneTitleService.read("?$filter=IsActive eq true", true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        response[i]["DisplayDescription"] = response[i].SubZone + " - " + response[i].Title;
      }
    })

  }


  ZoneEditForm = this.formBuilder.group({
    ZoneId: [],
    Description: [],
  })

  SubZoneEditForm = this.formBuilder.group({
    ZoneId: [],
    Description: [],
  })

  HandleFromSelectionChange() {
    var self = this;
    this.TntToolService.service.read('/' + this.SelectedFromZone.Id + '/' + this.SelectedFromSubZone.SubZoneId + '/toolcount', true).then(function (response) {
      self.countFrom = response;
      if (self.isDebug) console.log(response)
    });
  }

  HandleToSelectionChange() {
    var self = this;
    this.TntToolService.service.read('/' + this.SelectedToZone.Id + '/' + this.SelectedToSubZone.SubZoneId + '/toolcount', true).then(function (response) {
      self.countTo = response;
      if (self.isDebug) console.log(self.countTo)
    });
  }

  HandleFromZoneDisplay(value: any) {
    var self = this;
    this.SelectedFromZone = value;
    this.SelectedFromSubZone = undefined;
    this.fromComboBox.reset();
    this.countFrom = undefined;
    this.baseService.read(this.SelectedFromZone.Id + "/subzonetitle?$filter=IsActive eq true", true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        response[i]["DisplayDescription"] = response[i].SubZone + " - " + response[i].Title.trim();
      }

      response = response.filter(function (subzone) {
        return subzone.CenterId === self.bodyShopId
      });

      self.fromSubZones = response;
    });
    // this.SelectedFromZone = undefined;
    // this.SelectedFromSubZone = undefined;
    if (value) {
      this.dataResultZone =
        this.ZoneService.data.filter((s) => {
          return s.ZoneId == value.Id;

        })
      if (this.isDebug) console.log("From Zone", value)
    }
  }

  HandleFromSubZoneDisplay(value: any) {
    this.SelectedFromSubZone = value;
    // this.SelectedFromZone = undefined;
    // this.SelectedFromSubZone = undefined;
    if (this.isDebug) console.log("From SubZone", value)
    if (value) {
      this.dataResultSubZone =
        this.SubZoneService.data.filter((s) => {
          return s.SubZoneId == value.Id;

        })
      this.FromZoneSubZoneCount()
      if (this.isDebug) console.log(this.FromZoneSubZoneCount)
    } else {
      this.countFrom = undefined;
    }
  }


  HandleToZoneDisplay(value: any) {
    var self = this;
    this.SelectedToZone = value;
    this.SelectedToSubZone = undefined;
    this.toComboBox.reset();
    this.countTo = undefined;
    this.baseService.read(this.SelectedToZone.Id + "/subzonetitle?$filter=IsActive eq true", true).then(function (response) {
      for (var i = 0; i < response.length; i++) {
        response[i]["DisplayDescription"] = response[i].SubZone + " - " + response[i].Title.trim();
      }

      response = response.filter(function (subzone) {
        return subzone.CenterId === self.bodyShopId
      });
      //self.SubZoneTitleService.data = response;
      self.toSubZones = response;
    });
    if (value) {
      this.dataResultZone =
        this.ZoneService.data.filter((s) => {
          return s.ZoneId == value.Id;

        })
      if (this.isDebug) console.log("To Zone", this.SelectedToZone)
    } 
  }

  HandleToSubZoneDisplay(value: any) {
    this.SelectedToSubZone = value;
    // this.SelectedFromZone = undefined;
    // this.SelectedFromSubZone = undefined;
    if (value) {
      this.dataResultSubZone =
        this.SubZoneService.data.filter((s) => {
          return s.SubZoneId == value.Id;

        })
      this.ToZoneSubZoneCount()
      if (this.isDebug) console.log(this.ToZoneSubZoneCount)

    }
    else {
      this.countTo = undefined;
    }
  }


  FromZoneSubZoneCount = () => {
    var self = this;
    self.TntToolService.service.read('/' + this.SelectedFromZone.Id + '/' + this.SelectedFromSubZone.SubZoneId + '/toolcount', true).then(function (response) {

      self.countFrom = response;
      if (self.isDebug) console.log("From COUNT", response)
    });

  }

  ToZoneSubZoneCount = () => {
    var self = this;
    self.TntToolService.service.read('/' + this.SelectedToZone.Id + '/' + this.SelectedToSubZone.SubZoneId + '/toolcount', true).then(function (response) {

      self.countTo = response
      if (self.isDebug) console.log("To SubZone", response)
    });

  }




  ToolTransfer = () => {
    var TransferId = 'transfer?fromZoneId=' + this.SelectedFromZone.Id + '&fromSubZoneId=' + this.SelectedFromSubZone.SubZoneId + '&toZoneId=' + this.SelectedToZone.Id + '&toSubZOneId=' + this.SelectedToSubZone.SubZoneId


    var self = this;
    self.TntToolService.service.save({ Id: TransferId }, false)
      .then(function (transfer) {
        self.transfer = transfer;
        if (self.isDebug) console.log("Count was Successful", transfer)
        self.CgpAlertDialogService.showAlertDialog({
          title: 'Transfer Tool(s)',
          message: self.countFrom + ' Tool(s) were successfully transferred',
          alert: '',
          closeLabel: 'Close',
        })

        self.ToZoneSubZoneCount();
        self.FromZoneSubZoneCount();


      })
  };

  handleFilter(event?: any) { }

}
